// Must evaluate before React/App (imported first from bootstrap.jsx).

// Polyfill crypto.randomUUID for Safari < 15.4 and non-secure contexts (HTTP).
if (typeof crypto !== "undefined" && typeof crypto.randomUUID !== "function") {
  const randomUUIDImpl = function () {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (c) {
      var r = crypto.getRandomValues(new Uint8Array(1))[0];
      return (c ^ (r & (15 >> (c / 4)))).toString(16);
    });
  };
  try {
    Object.defineProperty(crypto, "randomUUID", {
      value: randomUUIDImpl,
      configurable: true,
      writable: true,
      enumerable: false,
    });
  } catch (e) {
    try {
      crypto.randomUUID = randomUUIDImpl;
    } catch (e2) {
      if (typeof window !== "undefined") {
        window.__ddRandomUUIDFallback = randomUUIDImpl;
      }
    }
  }
}

// Capture password-reset recovery params before Supabase or any React code consumes the URL.
(function capturePasswordResetRecovery() {
  if (typeof window === "undefined") return;
  const hash = window.location.hash?.substring(1) || "";
  const search = window.location.search?.substring(1) || "";
  const hashParams = new URLSearchParams(hash);
  const searchParams = new URLSearchParams(search);
  const fromHash = hashParams.get("type") === "recovery" && hashParams.get("access_token");
  const fromSearch = searchParams.get("type") === "recovery" && searchParams.get("access_token");
  if (fromHash) {
    try {
      sessionStorage.setItem("dd_reset_recovery", hash);
    } catch (e) {}
    if (window.location.pathname !== "/reset-password") {
      window.location.replace("/reset-password#" + hash);
    }
    return;
  }
  if (fromSearch) {
    try {
      sessionStorage.setItem("dd_reset_recovery", search);
    } catch (e) {}
    if (window.location.pathname !== "/reset-password") {
      window.location.replace("/reset-password#" + search);
    }
  }
})();

window.addEventListener(
  "error",
  (event) => {
    if (
      event.message?.includes("ERR_BLOCKED_BY_CLIENT") ||
      event.filename?.includes("googletagmanager.com") ||
      event.filename?.includes("posthog.com") ||
      event.filename?.includes("google-analytics.com") ||
      event.filename?.includes("gtm.js") ||
      event.message?.includes("Script error") ||
      (event.message?.includes("ServiceWorker") && event.message?.includes("facebook.com"))
    ) {
      event.preventDefault();
      return true;
    }
  },
  true
);

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason?.message || event.reason?.toString() || "";
  if (
    reason.includes("ERR_BLOCKED_BY_CLIENT") ||
    (reason.includes("Failed to fetch") &&
      (reason.includes("googletagmanager") || reason.includes("posthog.com"))) ||
    (reason.includes("Internal error opening backing store") &&
      reason.toLowerCase().includes("indexeddb"))
  ) {
    event.preventDefault();
  }
});
